import ErrorToast from "../../../components/common/toasts/ErrorToast";
import React, { useEffect, useId, useState } from "react";
import Select from "react-select";
import usePremiumResource from "../hooks/usePremiumResource";

/** Wyszukiwanie i stronicowanie użytkowników wewnątrz jednego pola wyboru. */
export default function UserPicker({
  token,
  value,
  onChange,
  label,
  chamberId,
  operators = false,
  disabled = false,
  excludedIds = [],
}) {
  const id = useId();
  const [search, setSearch] = useState("");
  const [query, setQuery] = useState("");
  const [page, setPage] = useState(0);
  const [results, setResults] = useState({ scope: null, users: [] });
  useEffect(() => {
    if (search.trim() === query) return;
    const timer = setTimeout(() => {
      setQuery(search.trim());
      setPage(0);
    }, 300);
    return () => clearTimeout(timer);
  }, [search, query]);
  const scope = JSON.stringify([token, chamberId, operators, query]);
  const params = new URLSearchParams({
    q: query,
    page: String(page),
    operators: String(operators),
  });
  if (chamberId) params.set("chamberId", chamberId);
  if (value) params.set("selectedId", value);
  const { data, loading, error, reload } = usePremiumResource(
    token,
    operators && !chamberId ? null : `/admin/users?${params}`,
  );
  useEffect(() => {
    if (!data) return;
    setResults((previous) => ({
      scope,
      selectedUser: data.selectedUser,
      users: [
        ...new Map(
          [
            ...(page > 0 && previous.scope === scope ? previous.users : []),
            ...(data.users || []),
          ].map((user) => [user.id, user]),
        ).values(),
      ],
    }));
  }, [data, page, scope]);
  const waiting = search.trim() !== query;
  const users = results.scope === scope ? results.users : [];
  const selected =
    data?.selectedUser ||
    users.find((user) => user.id === value) ||
    (results.selectedUser?.id === value ? results.selectedUser : null);
  return (
    <div className="premium-field">
      <label htmlFor={id}>{label}</label>
      <Select
        inputId={id}
        instanceId={id}
        name={id}
        classNamePrefix="premium-select"
        options={waiting ? [] : users}
        value={
          value
            ? selected || {
                id: value,
                name: "Wybrany użytkownik — sprawdź dostępność",
              }
            : null
        }
        getOptionValue={(user) => user.id}
        getOptionLabel={(user) =>
          `${user.name}${excludedIds.includes(user.id) ? " (ma już dostęp)" : ""}`
        }
        isOptionDisabled={(user) => excludedIds.includes(user.id)}
        onChange={(user) => onChange({ target: { value: user?.id || "" } })}
        inputValue={search}
        onInputChange={(text) => setSearch(text.slice(0, 200))}
        onMenuScrollToBottom={() => {
          if (!loading && !waiting && data?.hasMore) setPage(page + 1);
        }}
        filterOption={null}
        captureMenuScroll
        required
        isClearable
        isDisabled={disabled || (operators && !chamberId)}
        isLoading={loading || waiting}
        placeholder={
          operators && !chamberId
            ? "Najpierw wybierz izbę"
            : "Wybierz lub wpisz nazwisko / e-mail…"
        }
        noOptionsMessage={() =>
          error
            ? "Nie udało się pobrać użytkowników"
            : "Brak pasujących użytkowników"
        }
        loadingMessage={() => "Wyszukiwanie…"}
        menuPortalTarget={document.body}
        components={{ IndicatorSeparator: null }}
      />
      <ErrorToast message={error} />
      {error && (
        <button
          type="button"
          className="btn btn-outline-primary btn-sm"
          onClick={reload}
        >
          Ponów wyszukiwanie
        </button>
      )}
    </div>
  );
}
